export default {"src":"/_next/static/media/arrowRight.cbd93bdf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};